import { get } from 'lodash';

/**
 * A handy helper to ensure we can get a valid image src property from both
 * jpg/png AND non non-jpg/png images, without being tied a specific field name:
 * FUTURE TODO: centralise this, and use in all contexts? Some overlap with ENG-5230.
 *
 * @param {object} pageData page object returned by associated graphQL query.
 * @param {string} imageFieldName name of this specific image field (as there's no consistency 😮‍💨)
 */
const getImageHelper = (pageData, imageFieldName) => {
  // A better quality version, only available to JPG/PNG file types:
  const outputImgSrc = get(pageData, `${imageFieldName}.gatsbyImageData.images.fallback.src`)
  // Global fallback:
  || get(pageData, `${imageFieldName}.gatsbyImageData.images.sources[0].srcSet`)?.split(' ')[0];

  return outputImgSrc;
};

export default getImageHelper;
